import pxToRem from "assets/theme/functions/pxToRem";

const input = {
  styleOverrides: {
    root: {
      display: "flex !important",
      minHeight: pxToRem(42),
      padding: `${pxToRem(7)} ${pxToRem(14)} !important`,
      border: "1px solid #CBD5E1",
      borderRadius: `${pxToRem(11)} !important`,
      backgroundColor: "#ffffff",
      transition: "border-color .2s ease, box-shadow .2s ease, background-color .2s ease",
      "&:hover": {
        borderColor: "#7DD3FC",
      },
      "&.Mui-focused": {
        borderColor: "#0284C7",
        boxShadow: "0 0 0 3px rgba(2, 132, 199, 0.10)",
      },
      "& fieldset": {
        border: "none !important",
      },
    },
    input: {
      height: pxToRem(24),
      width: "100% !important",
      color: "#0F172A",
      fontSize: pxToRem(13),
    },
    inputSizeSmall: {
      height: pxToRem(18),
    },
  },
};

export default input;
